export const SCROLL_TO_ID = 'container'
export const PROFILE_DELETE_FORM = 'profile-delete-form'
